import {
  PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_configurableOptions as ConfigurableOptions,
  PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as MagentoProductVariant,
} from '../../hook/__generated__/PricingPageShopProduct';

export const attributeCodes = {
  primary: 'package_type',
  secondary: 'license_code',
};

const sortOrder = {
  [attributeCodes.primary]: 0,
  [attributeCodes.secondary]: 1,
};

interface VariantOptions {
  [key: string]: string;
}

export const getVariantOptions = (
  variant: MagentoProductVariant
): VariantOptions =>
  variant?.attributes?.reduce((acc, attribute) => {
    const code = attribute?.code;
    if (code) {
      return { ...acc, [code]: attribute?.uid };
    }
    return acc;
  }, {}) || {};

export const getDropdownData = (
  configurableOptions: Array<ConfigurableOptions | null>,
  selectedVariant: MagentoProductVariant,
  variants: Array<MagentoProductVariant | null> | null
): Array<ConfigurableOptions | null> => {
  const optionsSorted: Array<ConfigurableOptions | null> = configurableOptions
    .slice()
    .sort((a, b) => {
      if (a?.attributeCode && b?.attributeCode) {
        return sortOrder[a?.attributeCode] - sortOrder[b?.attributeCode];
      }
      return 0;
    });

  const selection = getVariantOptions(selectedVariant);

  const dropdownsData: Array<ConfigurableOptions | null> = optionsSorted.map(
    (item, index): ConfigurableOptions | null => {
      if (item === null) {
        return null;
      }
      if (index === 0) {
        return item;
      }

      const prevSelected = optionsSorted[index - 1]?.attributeCode;
      const filteredVariants = variants?.filter((variant) => {
        return variant?.attributes?.find(
          (attribute) =>
            prevSelected && attribute?.uid === selection?.[prevSelected]
        );
      });
      const validAttributeUids = filteredVariants?.map((variant) => {
        const attribute = variant?.attributes?.find(
          (attribute) => attribute?.code === optionsSorted[index]?.attributeCode
        );
        return attribute?.uid;
      });
      const filteredOptions: ConfigurableOptions['values'] =
        optionsSorted?.[index]?.values?.filter((item) => {
          return item?.uid && validAttributeUids?.includes(item?.uid);
        }) || null;
      return {
        ...item,
        values: filteredOptions,
      };
    }
  );

  return dropdownsData;
};
